import { actionTypes } from "./ActionTypes";

const initialState = {
    loadingScreen: false,
    showAlert: {
        message: '',
        severity: '',
        btnText: 'OK',
        open: false,
        nextId: '',
    },
    userDetails: {},
    authLoaded: false
};
const Reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_LOADING_SCREEN:
            return {
                ...state,
                loadingScreen: action.payload,
            };
        case actionTypes.SHOW_ALERT:
            return {
                ...state,
                showAlert: {
                    message: action.payload.message,
                    severity: action.payload.severity,
                    btnText: action.payload.btnText || 'OK',
                    open: action.payload.open || false,
                    nextId: action.payload.nextId || '',
                }
            };
        case actionTypes.USER_LOGIN:
            return {
                ...state,
                userDetails: action.payload,
            };
        case actionTypes.LOGOUT:
            return {
                ...state,
                ...initialState,
                authLoaded: true,
            }
        case actionTypes.AUTH_LOADED:
            return {
                ...state,
                authLoaded: action.payload
            }
        default:
            return state;
    }
};

export default Reducer;